import moment from 'moment-timezone';

/**
 * Adapter to convert API data to model object
 */
export abstract class ApiAdapter<T, S = unknown> {
  readonly brusselsTimezone = 'Europe/Brussels';

  /**
   * Transform json to a list of <T>Object
   */
  list(json, ...args): T[] {
    if (!json) {
      return [];
    }
    return json.map((it) => this.get(it, ...args));
  }

  parseToBrusselsTimezone(date: Date | string | number): moment.Moment {
    return moment.tz(date, this.brusselsTimezone);
  }

  parseDateAndTime(value: string | number | Date): moment.Moment {
    return moment.tz(value, moment.tz.guess());
  }

  /**
   * Transform json to a <T>Object
   */
  abstract get(json: S, ...args: unknown[]): T;
}
